import http from './ajaxRequest';
export default http;